<template>
  <div v-if="page">
    <vue-title title="Teams - Whoosh! Your Indoor Cycling Solution"></vue-title>

    <section class="teams-main teams-page-wrap clearfix">
      <div class="container">
        <div class="row">
          <section class="col-md-12">
            <TeamList
              :teams="publicTeams"
              :loading="loading"
              :pagination="pagination"
              :team-detail-base-url="teamDetailBaseUrl"
              :is-my-teams="false"
              @page-changed="handlePageChange"
            />
          </section>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TeamList from "@/components/team/TeamList";

export default {
  name: "Teams",
  data() {
    return {
      teamDetailBaseUrl: process.env.VUE_APP_TEAM_DETAIL_URL || "",
    };
  },
  components: {
    TeamList,
  },

  computed: {
    ...mapGetters("team", ["publicTeams", "loading", "pagination"]),
    ...mapGetters("page", ["page"]),
  },

  mounted() {
    document.body.classList.add("teams-page");
    this.loadTeams();
    //this.$store.dispatch("page/view", "teams");
  },

  destroyed() {
    document.body.classList.remove("teams-page");
  },

  methods: {
    loadTeams(page = 1) {
      this.$store.dispatch("team/fetchPublicTeams", { page, limit: 15 });
    },

    handlePageChange(page) {
      this.loadTeams(page);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style scoped>
.teams-page-wrap {
  padding: 40px 0;
}
</style>
